import React from "react";

import t from "../../../../Common/utils/translation/translator";

import MsxIcons from "../../../../Common/components/Icons/MsxIcons/MsxIcons";

import AxisSelectionFilterCheckboxInput from "./AxisSelectionFilterCheckboxInput";

// section that contains the 3 checkboxes (with cover strip, anti-static belt, increased corrosion protection)
const AxisSelectionFilterCheckboxesFiltersSection = ({
  cartesianFilters,
  handleCoverStripChange,
  handleAntistaticBeltChange,
  handleIncreasedCorrosionProtectionChange,
  isLoadingOrFetchingGetAxesCombinations,
  dependencies
}) => {
  return (
    <div className="flex flex-col flex-1">
      <div className="space-y-1">
        <span className="flex items-center space-x-1 text-gray-600">
          <span className="font-semibold">{t("cartesian.ui.stepper.axisoptionscamel")}</span>
          <MsxIcons name="info" size="nano" />
        </span>
        <AxisSelectionFilterCheckboxInput
          label={t("cartesian.ui.axis_selection.with_cover_strip")}
          checked={cartesianFilters?.applicationDataFilter?.withCoverstrip}
          onChange={handleCoverStripChange}
          disabled={
            dependencies?.withCoverStripSwitchable === false ||
            cartesianFilters?.applicationDataFilter?.withIncreasedCorrosionProtection
          }
          isLoading={isLoadingOrFetchingGetAxesCombinations}
          title={dependencies?.withCoverStripSwitchable === false && t("msizer.ui.tooltip.cannot_change_option")}
        />
      </div>

      <div className="space-y-1">
        <AxisSelectionFilterCheckboxInput
          label={t("cartesian.ui.axis_selection.antistatic_belt")}
          checked={cartesianFilters?.applicationDataFilter?.withAntistaticBelt}
          onChange={handleAntistaticBeltChange}
          disabled={
            dependencies?.withAntistaticBeltSwitchable === false ||
            cartesianFilters?.applicationDataFilter?.withSupportAxis
          }
          isLoading={isLoadingOrFetchingGetAxesCombinations}
          title={dependencies?.withAntistaticBeltSwitchable === false && t("msizer.ui.tooltip.cannot_change_option")}
        />
      </div>
      <div className="space-y-1">
        <AxisSelectionFilterCheckboxInput
          label={t("cartesian.ui.axis_selection.increased_corrosion_protection")}
          checked={cartesianFilters?.applicationDataFilter?.withIncreasedCorrosionProtection}
          onChange={handleIncreasedCorrosionProtectionChange}
          disabled={
            dependencies?.withIncreasedCorrosionProtectionSwitchable === false ||
            cartesianFilters?.applicationDataFilter?.withCoverstrip
          }
          isLoading={isLoadingOrFetchingGetAxesCombinations}
          title={
            dependencies?.withIncreasedCorrosionProtectionSwitchable === false &&
            t("msizer.ui.tooltip.cannot_change_option")
          }
        />
      </div>
    </div>
  );
};

export default AxisSelectionFilterCheckboxesFiltersSection;
